module.exports = __webpack_public_path__ + "static/media/flip.ca7b4702.svg";